/* Blazoer free-scroll: vervangt Slick op .custom_slider door een vloeiende, vrij scrollbare strook */
(function ($) {
  if (!$ || !$.fn || !$.fn.slick) return;
  var css = '.fs-track{display:flex!important;flex-wrap:nowrap;overflow-x:auto;overflow-y:hidden;scroll-snap-type:none;scroll-behavior:auto;-webkit-overflow-scrolling:touch;overscroll-behavior-x:contain;scrollbar-width:none;margin:0;padding:0;list-style:none;cursor:grab;touch-action:pan-x pan-y}' +
    '.fs-track::-webkit-scrollbar{display:none}' +
    '.fs-track.fs-dragging{cursor:grabbing;user-select:none}' +
    '.fs-track.fs-dragging a,.fs-track.fs-dragging img{pointer-events:none}' +
    '.fs-track>*{flex:0 0 calc(100% / var(--fs-n,4));max-width:calc(100% / var(--fs-n,4));min-width:0}' +
    '.fs-track img{-webkit-user-drag:none;user-select:none}' +
    '.fs-arrow-off{opacity:.3;pointer-events:none}' +
    /* pijlen klein en netjes onder de strook, rechts uitgelijnd */
    '.shopify-section .custom_arrows_wrapper{margin:0!important;padding:10px 13px;justify-content:flex-end;align-items:center;gap:12px}' +
    '.shopify-section .custom_arrows_wrapper .prev,.shopify-section .custom_arrows_wrapper .next{width:20px!important;height:20px!important;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:opacity .2s}' +
    '.shopify-section .custom_arrows_wrapper svg{width:20px!important;height:20px!important}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var orig = $.fn.slick;
  $.fn.slick = function (opts) {
    var self = this;
    if (typeof opts === 'object' || typeof opts === 'undefined') {
      var rest = self.filter(function () { return !$(this).hasClass('custom_slider'); });
      self.filter('.custom_slider').each(function () { initFree(this, opts || {}); });
      if (rest.length) orig.apply(rest, arguments);
      return self;
    }
    return orig.apply(self.filter(':not(.fs-track)'), arguments);
  };
  $.fn.slick.prototype = orig.prototype;

  function perView(o) {
    var w = window.innerWidth, n = o.slidesToShow || 1;
    (o.responsive || []).slice().sort(function (a, b) { return b.breakpoint - a.breakpoint; }).forEach(function (r) {
      if (w < r.breakpoint && r.settings && r.settings.slidesToShow) n = r.settings.slidesToShow;
    });
    return n <= 1 ? 1.2 : n; /* op mobiel een stukje van de volgende foto laten zien */
  }

  function initFree(el, o) {
    if (el.classList.contains('fs-track')) return;
    el.classList.add('fs-track');
    var setN = function () { el.style.setProperty('--fs-n', perView(o)); };
    setN(); window.addEventListener('resize', setN);

    /* pijlen: één kaart vloeiend verder schuiven */
    var prev = o.prevArrow && $(o.prevArrow), next = o.nextArrow && $(o.nextArrow);
    var step = function () { var c = el.firstElementChild; return c ? c.getBoundingClientRect().width : el.clientWidth / 3; };
    var go = function (dir) { cancelMomentum(); el.scrollBy({ left: dir * step(), behavior: 'smooth' }); };
    if (prev && prev.length) prev.off('.fs').on('click.fs', function (e) { e.preventDefault(); go(-1); });
    if (next && next.length) next.off('.fs').on('click.fs', function (e) { e.preventDefault(); go(1); });
    var upd = function () {
      var max = el.scrollWidth - el.clientWidth - 2;
      if (prev) prev.toggleClass('fs-arrow-off', el.scrollLeft <= 2);
      if (next) next.toggleClass('fs-arrow-off', el.scrollLeft >= max);
    };
    el.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); setTimeout(upd, 50);

    /* muis slepen met uitrollen (touch en trackpad gebruiken native scroll) */
    var down = false, moved = false, startX = 0, startLeft = 0, lastX = 0, lastT = 0, v = 0, raf = 0;
    function cancelMomentum() { if (raf) { cancelAnimationFrame(raf); raf = 0; } }
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      cancelMomentum(); down = true; moved = false;
      startX = lastX = e.clientX; startLeft = el.scrollLeft; lastT = performance.now(); v = 0;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 5) { moved = true; el.classList.add('fs-dragging'); }
      if (!moved) return;
      el.scrollLeft = startLeft - dx;
      var now = performance.now(), dt = now - lastT;
      if (dt > 0) v = 0.8 * ((lastX - e.clientX) / dt) + 0.2 * v;
      lastX = e.clientX; lastT = now;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return; down = false;
      if (!moved) return;
      setTimeout(function () { el.classList.remove('fs-dragging'); }, 0);
      if (performance.now() - lastT > 80) v = 0; /* stilgehouden voor loslaten: niet doorrollen */
      v = Math.max(-2.5, Math.min(2.5, v));
      var vel = v * 16, prevT = performance.now();
      (function tick(t) {
        var dt = Math.min(32, t - prevT) || 16; prevT = t;
        vel *= Math.pow(0.94, dt / 16);
        if (Math.abs(vel) < 0.3) { raf = 0; return; }
        el.scrollLeft += vel * dt / 16;
        raf = requestAnimationFrame(tick);
      })(prevT);
    });
    el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
    el.addEventListener('wheel', cancelMomentum, { passive: true });
    el.addEventListener('touchstart', cancelMomentum, { passive: true });
  }
})(window.jQuery);

/* Blazoer free-scroll (mobiel): productfoto's als vloeiende strook i.p.v. Splide-slider. Desktop (>=1024px) blijft ongewijzigd. */
(function () {
  var mq = window.matchMedia('(max-width: 1023.98px)');
  if (!mq.matches) return;

  var css = '@media (max-width:1023.98px){' +
    '.fs-gallery{visibility:visible!important}' +
    '.fs-gallery .splide__track{overflow-x:auto!important;overflow-y:hidden;scroll-snap-type:none;-webkit-overflow-scrolling:touch;overscroll-behavior-x:contain;scrollbar-width:none;max-height:none!important}' +
    '.fs-gallery .splide__track::-webkit-scrollbar{display:none}' +
    '.fs-gallery .splide__list{display:flex!important;flex-wrap:nowrap;gap:2px;width:auto!important;transform:none!important}' +
    '.fs-gallery .splide__slide{display:block!important;flex:0 0 88%!important;width:88%!important;max-width:88%!important;margin:0!important}' +
    '.fs-gal-bar{position:relative;height:2px;margin:12px 16px 0;border-radius:2px;overflow:hidden}' +
    '.fs-gal-bar::before{content:"";position:absolute;inset:0;background:currentColor;opacity:.15}' +
    '.fs-gal-bar span{position:absolute;top:0;left:0;bottom:0;background:currentColor;opacity:.85;border-radius:2px}' +
    '}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  /* Splide uitschakelen voordat het thema hem start */
  function claim(el) {
    if (el.__fsDone) return; el.__fsDone = true;
    el.removeAttribute('data-slideshow-enabled');
    el.classList.add('fs-gallery');
  }
  var obs = new MutationObserver(function () {
    var el = document.querySelector('.splide--product');
    if (el) claim(el);
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', function () {
    obs.disconnect();
    var el = document.querySelector('.splide--product');
    if (!el) return;
    claim(el);
    var track = el.querySelector('.splide__track');
    if (!track) return;

    /* dunne voortgangsbalk onder de foto's */
    var bar = document.createElement('div'); bar.className = 'fs-gal-bar';
    var thumb = document.createElement('span'); bar.appendChild(thumb);
    track.parentNode.insertBefore(bar, track.nextSibling);
    var upd = function () {
      var max = track.scrollWidth - track.clientWidth;
      var ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
      bar.style.display = max > 2 ? '' : 'none';
      thumb.style.width = (ratio * 100) + '%';
      thumb.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * ((1 / ratio) - 1) * 100 : 0) + '%)';
    };
    track.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    window.addEventListener('load', upd);
    upd();

    var scrollToMedia = function (id) {
      var m = id && el.querySelector('[data-media-id="' + id + '"]');
      var li = m && m.closest('li');
      if (!li) return;
      track.scrollTo({ left: track.scrollLeft + li.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: 'smooth' });
    };

    /* kleur/variant kiezen: strook naar de juiste foto schuiven (zonder de pagina te verspringen) */
    var tries = 0;
    (function hook() {
      var comp = el.closest('[x-data]');
      var d = comp && comp.__x && comp.__x.$data;
      if (!d || typeof d.scrollToVariantImage !== 'function') { if (tries++ < 50) setTimeout(hook, 100); return; }
      var origSwap = d.swapVariantImage;
      d.scrollToVariantImage = function () {
        if (!mq.matches) return;
        var v = this.current_variant;
        if (v && v.featured_media) { this.current_media_id = v.featured_media.id; scrollToMedia(v.featured_media.id); }
      };
      if (typeof origSwap === 'function') {
        d.swapVariantImage = function () {
          var r = origSwap.apply(this, arguments);
          track.scrollTo({ left: 0, behavior: 'smooth' });
          return r;
        };
      }
    })();
  });
})();
